export default __webpack_public_path__ + "static/media/zip.5a9284bd.png";